(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sapiato-complements-assets"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sapiato-complements')) {
    class SapiatoComplements extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const options = {signal: this.abort.signal};
        this.scope = this.closest('[data-product-form-wrapper]') || this;
        this.variants = JSON.parse(this.querySelector('[data-sx-main-variants]')?.textContent || '[]');
        this.cards = [...this.querySelectorAll('[data-sx-card]')];
        if (this.hasAttribute('data-sx-dynamic')) this.selectRecommendations();
        this.format = new Intl.NumberFormat(document.documentElement.lang || 'fr', {style: 'currency', currency: this.dataset.currency});
        this.scope.addEventListener('change', () => this.update(), options);
        this.scope.addEventListener('input', () => this.update(), options);
        this.scope.addEventListener('submit', event => {
          if (this.busy && event.target.id === this.dataset.formId) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, {...options, capture: true});
        this.addEventListener('click', event => {
          const add = event.target.closest('[data-sx-add], [data-sx-bundle]');
          if (add) {
            event.preventDefault();
            event.stopPropagation();
            this.add(add);
          }
          const link = event.target.closest('[data-sx-link]');
          if (link && !this.hasAttribute('data-sapiato-aov')) this.track('sapiato_recommendation_click', link.closest('[data-sx-card]'));
        }, options);
        if (this.dataset.mode === 'look') {
          this.observer = new MutationObserver(records => {
            if (records.some(record => !this.contains(record.target))) {
              cancelAnimationFrame(this.frame);
              this.frame = requestAnimationFrame(() => this.update());
            }
          });
          this.observer.observe(this.scope, {childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'disabled']});
        }
        if (!this.hasAttribute('data-sapiato-aov')) {
        this.impressions = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting || entry.target.dataset.sxImpressed) return;
            entry.target.dataset.sxImpressed = 'true';
            this.push({event: 'sapiato_recommendation_impression', context: this.context(), anchor_product: this.dataset.anchorProduct || 'cart', recommendations: [this.payload(entry.target)]});
            this.impressions.unobserve(entry.target);
          });
        }, {threshold: 0.25});
        this.cards.forEach(card => this.impressions.observe(card));
        }
        this.initPreview(options);
        this.update();
      }
      disconnectedCallback() {
        this.closePreview(true);
        this.abort?.abort();
        this.observer?.disconnect();
        this.impressions?.disconnect();
        cancelAnimationFrame(this.frame);
      }
      initPreview(options) {
        this.previewDialog = this.querySelector('[data-sxp-dialog]');
        if (!this.previewDialog || typeof this.previewDialog.showModal !== 'function') return;
        this.previewCache = new Map();
        this.addEventListener('click', event => {
          const trigger = event.target.closest('[data-sx-preview]');
          if (trigger && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
            event.preventDefault();
            if (!this.busy && !this.recovery) this.openPreview(trigger.closest('[data-sx-card]'), trigger);
          }
          if (event.target.closest('[data-sxp-close]') || event.target === this.previewDialog) this.closePreview();
          const step = event.target.closest('[data-sxp-step]');
          if (step) this.previewPhoto(this.previewIndex + Number(step.dataset.sxpStep));
          const add = event.target.closest('[data-sxp-add]');
          if (add) {
            event.preventDefault();
            this.commitPreviewChoice();
            this.add(add, this.previewCard);
          }
        }, options);
        this.previewDialog.addEventListener('change', event => {
          if (event.target.matches('[data-sxp-variant]')) {
            const option = event.target.selectedOptions?.[0];
            const figures = [...this.previewDialog.querySelectorAll('[data-sxp-photo]')];
            const index = figures.findIndex(figure => figure.dataset.imageId === option?.dataset.imageId);
            if (index >= 0) this.previewPhoto(index);
            if (option?.dataset.price) this.previewDialog.querySelector('[data-sxp-price]').textContent = this.format.format(Number(option.dataset.price) / 100);
            this.syncPreviewButton();
          }
        }, options);
        this.previewDialog.addEventListener('cancel', event => { event.preventDefault(); this.closePreview(); }, options);
      }
      async openPreview(card, trigger) {
        this.previewCard = card;
        this.previewTrigger = trigger;
        const dialog = this.previewDialog;
        const content = dialog.querySelector('[data-sxp-content]');
        content.replaceChildren();
        dialog.querySelector('[data-sxp-loading]').hidden = false;
        dialog.querySelector('[data-sxp-status]').textContent = '';
        dialog.querySelector('[data-sxp-cart]').hidden = true;
        dialog.querySelector('[data-sxp-fallback]').href = trigger.href;
        dialog.querySelector('[data-sxp-fallback]').hidden = false;
        dialog.setAttribute('aria-label', card.querySelector('.sx-card__title').textContent.trim());
        this.previewOldOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        dialog.showModal();
        dialog.scrollTop = 0;
        dialog.querySelector('[data-sxp-close]').focus();
        const url = new URL(trigger.href, window.location.origin);
        url.searchParams.set('section_id', 'sapiato-complement-preview');
        const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        this.previewRequest?.abort();
        const controller = new AbortController();
        this.previewRequest = controller;
        const timeout = setTimeout(() => controller.abort(), 12000);
        try {
          let markup = this.previewCache.get(url.href);
          if (!markup) {
            const response = await fetch(url.href, {credentials: 'same-origin', signal: controller.signal});
            if (!response.ok) throw new Error('preview-unavailable');
            markup = await response.text();
          }
          if (controller.signal.aborted || !dialog.open || this.previewCard !== card) return;
          const parsed = new DOMParser().parseFromString(markup, 'text/html').querySelector('[data-sxp-product]');
          if (!parsed || !parsed.querySelector('[data-sxp-variant]')) throw new Error('preview-unavailable');
          this.previewCache.set(url.href, markup);
          content.replaceChildren(parsed);
          dialog.querySelector('[data-sxp-fallback]').hidden = true;
          const field = dialog.querySelector('[data-sxp-variant]');
          const choice = this.choice(card);
          if (field.tagName === 'SELECT') {
            const option = [...field.options].find(item => item.value === choice.id && !item.disabled);
            field.value = option ? option.value : '';
          }
          this.previewPhoto(0);
          field.dispatchEvent(new Event('change', {bubbles: true}));
          this.syncPreviewButton();
        } catch (_error) {
          if (dialog.open && this.previewCard === card) dialog.querySelector('[data-sxp-status]').textContent = dialog.dataset.error;
        } finally {
          clearTimeout(timeout);
          if (this.previewCard === card) dialog.querySelector('[data-sxp-loading]').hidden = true;
        }
      }
      previewPhoto(index) {
        const photos = [...this.previewDialog.querySelectorAll('[data-sxp-photo]')];
        if (!photos.length) return;
        this.previewIndex = (index + photos.length) % photos.length;
        photos.forEach((photo, i) => { photo.hidden = i !== this.previewIndex; });
        const count = this.previewDialog.querySelector('[data-sxp-count]');
        if (count) count.textContent = count.dataset.pattern.replace('__current__', this.previewIndex + 1).replace('__total__', photos.length);
      }
      syncPreviewButton() {
        const dialog = this.previewDialog;
        if (!dialog?.open) return;
        const field = dialog.querySelector('[data-sxp-variant]');
        const button = dialog.querySelector('[data-sxp-add]');
        if (!field || !button) return;
        const option = field.selectedOptions?.[0] || field;
        const source = this.previewCard.querySelector('[data-sx-variant]');
        const sourceOption = source.tagName === 'SELECT' ? [...source.options].find(item => item.value === field.value) : source;
        button.disabled = Boolean(this.busy || this.recovery || !field.value || option.disabled || !sourceOption || sourceOption.disabled || field.dataset.available === 'false');
      }
      commitPreviewChoice() {
        const field = this.previewDialog.querySelector('[data-sxp-variant]');
        const source = this.previewCard.querySelector('[data-sx-variant]');
        source.value = field.value;
        source.dispatchEvent(new Event('change', {bubbles: true}));
      }
      closePreview(fromHistory = false) {
        const dialog = this.previewDialog;
        if (!dialog?.open) return;
        this.previewRequest?.abort();
        dialog.close();
        document.body.style.overflow = this.previewOldOverflow || '';
        this.previewTrigger?.focus({preventScroll: true});
      }

      selectRecommendations() {
        const pool = this.cards;
        const limit = Number(this.dataset.sxLimit || 2);
        const signature = pool.map(card => [card.dataset.recommendedProduct, card.dataset.score, card.dataset.family].join(':')).join('|');
        const key = ['sx-outfits-v2', this.dataset.mode, this.dataset.anchorProduct, new Date().toISOString().slice(0, 10), signature].join('::');
        let selected = [];
        try {
          const handles = JSON.parse(sessionStorage.getItem(key) || '[]');
          if (Array.isArray(handles)) selected = [...new Set(handles)].map(handle => pool.find(card => card.dataset.recommendedProduct === handle)).filter(Boolean).slice(0, limit);
        } catch (_error) {}
        while (selected.length < Math.min(limit, pool.length)) {
          let remaining = pool.filter(card => !selected.includes(card));
          const diverse = remaining.filter(card => !selected.some(item => item.dataset.family === card.dataset.family));
          if (diverse.length) remaining = diverse;
          const total = remaining.reduce((sum, card) => sum + Math.sqrt(Math.max(Number(card.dataset.score) || 1, 0.1)), 0);
          const weights = remaining.map(card => 0.2 / remaining.length + 0.8 * Math.sqrt(Math.max(Number(card.dataset.score) || 1, 0.1)) / total);
          let draw = Math.random();
          const next = remaining.find((card, index) => { draw -= weights[index]; return draw <= 0; }) || remaining[remaining.length - 1];
          selected.push(next);
        }
        pool.forEach(card => { card.hidden = !selected.includes(card); });
        selected.forEach((card, index) => { card.dataset.slot = String(index + 1); card.style.order = String(index + 1); });
        this.cards = selected;
        try { sessionStorage.setItem(key, JSON.stringify(selected.map(card => card.dataset.recommendedProduct))); } catch (_error) {}
      }
      context() { return this.dataset.mode === 'look' ? 'product' : 'cart'; }
      push(payload) {
        try {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push(payload);
        } catch (_error) {}
      }
      payload(card) {
        return {context: this.context(), experiment: 'dynamic_outfits_v2', anchor_product: card.dataset.anchorProduct || '', recommended_product: card.dataset.recommendedProduct, slot: Number(card.dataset.slot), score: Number(card.dataset.score), reason: card.dataset.reason || '', inventory_bucket: card.dataset.inventoryBucket || 'catalog_potential', recommended_product_price_cents: Number(card.dataset.priceCents)};
      }
      track(event, card) { this.push({event, ...this.payload(card)}); }
      choice(card) {
        const field = card.querySelector('[data-sx-variant]');
        const option = field.selectedOptions?.[0] || field;
        return {field, option, id: field.value, price: Number(option.dataset.price || 0)};
      }
      main() {
        const form = document.getElementById(this.dataset.formId);
        if (!form) return null;
        const data = new FormData(form);
        const id = String(data.get('id') || '');
        const variant = this.variants.find(item => item.id === id);
        const quantity = Number(data.get('quantity') || 1);
        if (!variant?.available || !Number.isInteger(quantity) || quantity < 1 || form.querySelector('[data-add-to-cart]')?.disabled) return null;
        const item = {id, quantity};
        const properties = Object.create(null);
        for (const [name, value] of data) {
          const match = name.match(/^properties\[(.+)\]$/);
          if (match && typeof value === 'string') properties[match[1]] = value;
        }
        if (Object.keys(properties).length) item.properties = properties;
        if (data.get('selling_plan')) item.selling_plan = String(data.get('selling_plan'));
        return {item, form, price: variant.price * quantity};
      }
      update() {
        if (this.busy || this.recovery) return;
        this.cards.forEach(card => {
          const choice = this.choice(card);
          if (choice.id) {
            card.querySelector('[data-sx-price]').textContent = this.format.format(choice.price / 100);
            card.dataset.priceCents = choice.price;
            const image = card.querySelector('img');
            if (image && choice.option.dataset.image && image.dataset.sxSource !== choice.option.dataset.image) {
              image.removeAttribute('srcset');
              image.src = choice.option.dataset.image;
              image.dataset.sxSource = choice.option.dataset.image;
            }
          }
          const button = card.querySelector('[data-sx-add]');
          if (button) button.disabled = !choice.id;
        });
        if (this.dataset.mode !== 'look') return;
        const main = this.main();
        const selected = this.cards.filter(card => card.querySelector('[data-sx-include]').checked);
        const complete = selected.length > 0 && selected.every(card => this.choice(card).id);
        this.querySelector('[data-sx-total]').textContent = main && complete ? this.format.format((main.price + selected.reduce((sum, card) => sum + this.choice(card).price, 0)) / 100) : '—';
        this.querySelector('[data-sx-bundle]').disabled = !main || !complete;
        const hint = this.querySelector('[data-sx-hint]');
        hint.hidden = Boolean(main && complete);
        hint.textContent = !main ? this.dataset.chooseMain : selected.length ? this.dataset.chooseVariants : this.dataset.pickAccessory;
      }
      async request(url, options = {}) {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), options.method === 'POST' ? 30000 : 12000);
        try {
          const response = await fetch(url, {...options, credentials: 'same-origin', cache: 'no-store', signal: controller.signal});
          const body = await response.json();
          return {response, body};
        } finally {
          clearTimeout(timeout);
        }
      }
      signature(item) {
        const properties = Object.entries(item.properties || {}).filter(([, value]) => value !== '').sort(([a], [b]) => a.localeCompare(b));
        return JSON.stringify([String(item.variant_id || item.id), String(item.selling_plan_allocation?.selling_plan?.id || item.selling_plan || ''), properties]);
      }
      totals(items) {
        const totals = new Map();
        items.forEach(item => {
          const key = this.signature(item);
          totals.set(key, (totals.get(key) || 0) + Number(item.quantity));
        });
        return totals;
      }
      async readCart() {
        const url = new URL(this.dataset.cartUrl, window.location.origin);
        url.pathname = url.pathname.replace(/\/$/, '') + '.js';
        const {response, body} = await this.request(url.href, {headers: {Accept: 'application/json'}});
        if (!response.ok || !Array.isArray(body.items)) throw new Error('cart-unavailable');
        this.cartSnapshot = body;
        return this.totals(body.items);
      }
      async complete(selected) {
        this.recovery = true;
        this.dataset.sxState = 'complete';
        selected.forEach(card => {
          const choice = this.choice(card);
          this.push({event: 'sapiato_recommendation_add_to_cart', ...this.payload(card), recommended_variant_id: choice.id, recommended_variant_title: choice.option.textContent?.trim() || ''});
        });
        if (this.keepProductPage) {
          this.recovery = false;
          this.closeAfterAdd = true;
          selected.forEach(card => { const check = card.querySelector('[data-sx-include]'); if (check) check.checked = true; });
          const status = this.querySelector('[data-sx-status]');
          status.classList.add('sx-success');
          status.textContent = this.previewDialog.dataset.added;
          this.querySelector('[data-sx-recovery]').hidden = false;
          try {
            await this.readCart();
            document.dispatchEvent(new CustomEvent('theme:cart:change', {detail: {cart: this.cartSnapshot}, bubbles: true}));
          } catch (_error) {}
          return;
        }
        const url = new URL(this.dataset.cartUrl, window.location.origin);
        const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
        if (preview && /^\d+$/.test(preview)) url.searchParams.set('preview_theme_id', preview);
        window.location.assign(url.href);
      }
      async add(button, previewCard = null) {
        if (this.busy || this.recovery || button.disabled) return;
        const group = button.hasAttribute('data-sx-bundle');
        const selected = group ? this.cards.filter(card => card.querySelector('[data-sx-include]').checked) : [previewCard || button.closest('[data-sx-card]')];
        if (!selected.length || selected.some(card => !this.choice(card).id)) return;
        let items = selected.map(card => ({id: this.choice(card).id, quantity: 1}));
        if (group) {
          const main = this.main();
          if (!main || !main.form.reportValidity()) { this.update(); return; }
          items.unshift(main.item);
        }
        this.keepProductPage = Boolean(previewCard);
        this.busy = true;
        this.setAttribute('aria-busy', 'true');
        this.querySelectorAll('button:not([data-sxp-close]), select, input[type="checkbox"]').forEach(control => { control.disabled = true; });
        this.querySelector('[data-sx-idle]')?.setAttribute('hidden', '');
        this.querySelector('[data-sx-busy]')?.removeAttribute('hidden');
        const status = this.querySelector('[data-sx-status]');
        const recovery = this.querySelector('[data-sx-recovery]');
        status.textContent = '';
        status.classList.remove('sx-success');
        recovery.hidden = true;
        let before;
        let sent = false;
        let rejected = false;
        let detail = '';
        try {
          this.dataset.sxState = 'checking';
          before = await this.readCart();
          if (group) {
            items = items.map(item => ({...item, quantity: Math.max(0, item.quantity - (before.get(this.signature(item)) || 0))})).filter(item => item.quantity > 0);
          }
          const addedCards = selected.filter(card => items.some(item => item.id === this.choice(card).id));
          if (!items.length) { await this.complete([]); return; }
          this.dataset.sxState = 'adding';
          sent = true;
          const {response, body} = await this.request(this.dataset.addUrl, {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({items})});
          rejected = !response.ok && [400, 404, 422].includes(response.status);
          detail = typeof body.description === 'string' ? body.description.slice(0, 1000) : '';
          const returned = Array.isArray(body.items) ? this.totals(body.items) : new Map();
          const requested = this.totals(items);
          const confirmed = response.ok && [...requested].every(([key, quantity]) => (returned.get(key) || 0) >= quantity + (before.get(key) || 0));
          if (!confirmed) throw new Error('unconfirmed');
          await this.complete(addedCards);
        } catch (_error) {
          if (!sent) {
            this.dataset.sxState = 'not-sent';
            status.textContent = this.dataset.connectionError;
            if (this.previewDialog?.open) this.previewDialog.querySelector('[data-sxp-status]').textContent = status.textContent;
          } else {
            this.dataset.sxState = 'verifying';
            let after;
            try { after = await this.readCart(); } catch (_cartError) {}
            const requested = this.totals(items);
            if (after && [...requested].every(([key, quantity]) => (after.get(key) || 0) >= (before.get(key) || 0) + quantity)) {
              await this.complete(selected.filter(card => items.some(item => item.id === this.choice(card).id)));
              return;
            }
            const unchanged = after && before.size === after.size && [...before].every(([key, quantity]) => after.get(key) === quantity);
            this.recovery = !(rejected && unchanged);
            this.dataset.sxState = this.recovery ? 'unconfirmed' : 'rejected';
            status.textContent = [detail, this.recovery ? this.dataset.error : this.dataset.rejectedError].filter(Boolean).join(' ');
            recovery.hidden = false;
            if (this.previewDialog?.open) {
              this.previewDialog.querySelector('[data-sxp-status]').textContent = status.textContent;
              this.previewDialog.querySelector('[data-sxp-cart]').hidden = false;
            } else if (this.recovery) recovery.focus();
          }
        } finally {
          this.busy = false;
          this.removeAttribute('aria-busy');
          this.querySelector('[data-sx-idle]')?.removeAttribute('hidden');
          this.querySelector('[data-sx-busy]')?.setAttribute('hidden', '');
          if (!this.recovery) {
            this.querySelectorAll('button:not([data-sxp-close]), select, input[type="checkbox"]').forEach(control => { control.disabled = false; });
            this.update();
            this.syncPreviewButton();
          }
          if (this.closeAfterAdd) { this.closeAfterAdd = false; this.closePreview(); }
          this.keepProductPage = false;
        }
      }
    }
    customElements.define('sapiato-complements', SapiatoComplements);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sapiato-product-card"] && !Shopify.designMode) return;
  try {
    (() => {
    const revealCardImages = (event) => {
      if (!(event.target instanceof Element)) return;
      const media = event.target.closest('.sapiato-product-card__media') ||
        event.target.closest('.sapiato-product-card__link--media')?.querySelector('.sapiato-product-card__media');
      if (!media) return;
      // The automatic first-card swipe is a hint, not a request for the gallery.
      const hintOnly = event.type === 'scroll' &&
        event.target.dataset.sapiatoHintPlayed === 'true' &&
        event.target.dataset.sapiatoUserInteracted !== 'true';
      if (hintOnly && event.target.dataset.sapiatoHintImageReady === 'true') return;
      const pending = [...media.querySelectorAll('template[data-sapiato-card-image]')];
      const requested = hintOnly ? pending.slice(0, 1) : pending;
      if (hintOnly) event.target.dataset.sapiatoHintImageReady = 'true';
      requested.forEach((template) => {
        template.replaceWith(template.content);
      });
    };
    document.addEventListener('pointerover', revealCardImages, { passive: true });
    document.addEventListener('pointerdown', revealCardImages, { passive: true });
    document.addEventListener('focusin', revealCardImages);
    document.addEventListener('scroll', (event) => {
      if (event.target instanceof Element && event.target.matches('[data-sapiato-product-carousel]')) {
        revealCardImages(event);
      }
    }, { capture: true, passive: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sapiato-product-presentation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sapiato-mobile-gallery')) {
    customElements.define('sapiato-mobile-gallery', class extends HTMLElement {
      connectedCallback() {
        this.grid = this.parentElement.querySelector('[data-product-slideshow]');
        if (!this.grid) return;
        this.counter = this.querySelector('[data-gallery-position]');
        this.buttons = [...this.querySelectorAll('button')];
        this.update = () => {
          this.cells = [...this.grid.querySelectorAll('.product__media:not(.hide)')];
          this.index = Math.max(0, this.cells.findIndex(cell => cell.classList.contains('is-selected')));
          const text = `${this.index + 1} / ${this.cells.length}`;
          if (this.counter.textContent !== text) this.counter.textContent = text;
          this.buttons.forEach(button => { button.disabled = !this.grid.classList.contains('flickity-enabled'); });
          if (!this.initialized && this.grid.classList.contains('flickity-enabled') && this.cells.length) {
            this.initialized = true;
            const id = this.closest('.sapiato-pdp')?.dataset.initialVariantMediaId;
            if (id && this.cells.some(cell => cell.dataset.mediaId === id)) {
              this.grid.dispatchEvent(new CustomEvent('theme:image:change', {detail: {id}}));
            }
          }
        };
        this.navigate = event => {
          const button = event.target.closest('button');
          if (!button || button.disabled || !this.cells.length) return;
          const step = button.hasAttribute('data-gallery-next') ? 1 : -1;
          const cell = this.cells[(this.index + step + this.cells.length) % this.cells.length];
          this.grid.dispatchEvent(new CustomEvent('theme:image:change', {detail: {id: cell.dataset.mediaId}}));
        };
        this.addEventListener('click', this.navigate);
        this.observer = new MutationObserver(this.update);
        this.observer.observe(this.grid, {attributes: true, attributeFilter: ['class'], childList: true, subtree: true});
        this.update();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.removeEventListener('click', this.navigate);
      }
    });
  }
  if (!customElements.get('sapiato-pdp-layout')) {
    customElements.define('sapiato-pdp-layout', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => {
          const host = this.closest('.shopify-section');
          if (!host) return;
          this.observed = [];
          this.resize = new ResizeObserver(entries => {
            for (const {target} of entries) {
              const value = `${target.getBoundingClientRect().height}px`;
              if (target.style.getPropertyValue('--pdp-content-height') !== value) {
                target.style.setProperty('--pdp-content-height', value);
              }
            }
          });
          const bind = () => {
            const nodes = [...host.querySelectorAll('.sapiato-pdp .product__grid--columns:not(.flickity-enabled), .sapiato-pdp .product__inner')];
            if (nodes.length === this.observed.length && nodes.every((node, i) => node === this.observed[i])) return;
            this.resize.disconnect();
            this.observed = nodes;
            nodes.forEach(node => this.resize.observe(node));
          };
          this.mutations = new MutationObserver(bind);
          this.mutations.observe(host, {childList: true, subtree: true});
          bind();
        });
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.resize?.disconnect();
        this.mutations?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sapiato-shipping-goal"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sapiato-shipping-goal')) {
    customElements.define('sapiato-shipping-goal', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        this.format = new Intl.NumberFormat(document.documentElement.lang || 'fr', {style: 'currency', currency: this.dataset.currency});
        document.addEventListener('theme:cart:change', event => {
          if (event.detail?.cart) this.update(event.detail.cart);
        }, {signal: this.abort.signal});
        const total = this.closest('[data-section-type="cart"]')?.querySelector('[data-cart-final]');
        if (total) {
          this.observer = new MutationObserver(() => {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => this.refresh(), 100);
          });
          this.observer.observe(total, {childList: true, subtree: true, characterData: true});
        }
      }
      disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); clearTimeout(this.timer); }
      update(cart) {
        if (!Number.isFinite(cart.total_price)) return;
        const remaining = Math.max(Number(this.dataset.threshold) - cart.total_price, 0);
        this.classList.toggle('sx-delivery--reached', remaining === 0);
        this.querySelector('[data-shipping-title]').textContent = remaining === 0 ? this.dataset.unlocked : this.dataset.goal.replace('__AMOUNT__', this.format.format(remaining / 100));
        this.querySelector('progress').value = Math.min(cart.total_price, Number(this.dataset.threshold));
      }
      async refresh() {
        try {
          const response = await fetch(this.dataset.cartUrl, {credentials: 'same-origin', cache: 'no-store', signal: this.abort.signal});
          if (response.ok) this.update(await response.json());
        } catch (_error) {}
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-predictive"] && !Shopify.designMode) return;
  try {
    (() => {
    const escapeHtml = (value) => String(value || '').replace(/[&<>"']/g, (character) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    })[character]);

    const normalizeSearchTerm = (value) => String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[\u2019']/g, '')
      .replace(/[^a-zA-Z0-9]+/g, ' ')
      .trim()
      .toLowerCase();

    const genericSearchTokens = new Set([
      'a',
      'avec',
      'blouse',
      'blouses',
      'body',
      'chemise',
      'chemises',
      'de',
      'des',
      'du',
      'en',
      'ensemble',
      'ensembles',
      'et',
      'femme',
      'femmes',
      'gilet',
      'gilets',
      'haut',
      'hauts',
      'jupe',
      'jupes',
      'la',
      'le',
      'les',
      'maille',
      'manteau',
      'manteaux',
      'pantalon',
      'pantalons',
      'pour',
      'pull',
      'pulls',
      'robe',
      'robes',
      'un',
      'une',
      'veste',
      'vestes',
      'vetement',
      'vetements'
    ]);

    const getSearchTokens = (value) => normalizeSearchTerm(value)
      .split(' ')
      .filter((token) => token.length > 1);

    const getSpecificSearchTokens = (value) => getSearchTokens(value)
      .filter((token) => !genericSearchTokens.has(token));

    const includesAnyPhrase = (value, phrases) => phrases.some((phrase) => value.includes(phrase));
    const recommendationScoreStorageKey = 'sapiato_search_recommendation_scores_v1';
    const recommendationScoreHalfLifeDays = 21;
    const recommendationScoreMaxItems = 80;

    const productConflictsWithTerm = (term, productText) => {
      const query = normalizeSearchTerm(term);
      const wantsLongSleeves = includesAnyPhrase(query, ['manche longue', 'manches longues', 'long sleeve']);
      const wantsShortSleeves = includesAnyPhrase(query, ['manche courte', 'manches courtes', 'short sleeve']);
      const wantsSleeveless = includesAnyPhrase(query, ['sans manche', 'sans manches', 'dos nu', 'bretelles']);
      const wantsLongDress = includesAnyPhrase(query, ['robe longue', 'robes longues', 'maxi dress']);
      const wantsShortDress = includesAnyPhrase(query, ['robe courte', 'robes courtes', 'mini robe', 'mini dress']);

      if (wantsLongSleeves && includesAnyPhrase(productText, ['sans manche', 'sans manches', 'manche courte', 'manches courtes', 'bretelle', 'bretelles'])) {
        return true;
      }

      if (wantsShortSleeves && includesAnyPhrase(productText, ['manche longue', 'manches longues', 'sans manche', 'sans manches'])) {
        return true;
      }

      if (wantsSleeveless && includesAnyPhrase(productText, ['manche longue', 'manches longues', 'manche courte', 'manches courtes'])) {
        return true;
      }

      if (wantsLongDress && includesAnyPhrase(productText, ['robe courte', 'robes courtes', 'mini robe', 'mini dress'])) {
        return true;
      }

      if (wantsShortDress && includesAnyPhrase(productText, ['robe longue', 'robes longues', 'maxi robe', 'maxi dress'])) {
        return true;
      }

      return false;
    };

    const formatPrice = (value, locale, currency) => {
      const amount = Number(value);
      if (!Number.isFinite(amount)) {
        return '';
      }

      try {
        return new Intl.NumberFormat(locale || 'fr-FR', {
          currency: currency || 'EUR',
          style: 'currency'
        }).format(amount);
      } catch (error) {
        return `${amount.toFixed(2)} ${currency || 'EUR'}`;
      }
    };

    class SapiatoPredictiveSearch {
      constructor(root) {
        this.root = root;
        this.form = root.querySelector('form');
        this.input = root.querySelector('[data-sapiato-predictive-input]');
        this.results = root.querySelector('[data-sapiato-predictive-results]');
        this.initial = root.querySelector('[data-sapiato-predictive-initial]');
        this.reset = root.querySelector('[data-sapiato-predictive-reset]');
        this.abortController = null;
        this.activeToggle = null;
        this.debounceTimer = null;
        this.recommendationScores = this.loadRecommendationScores();
        this.locale = root.dataset.locale || 'fr-FR';
        this.currency = root.dataset.currency || 'EUR';
        this.isDrawer = root.dataset.sapiatoPredictiveDrawer === 'true';
        this.curatedSuggestions = this.parseCuratedSuggestions();

        if (!this.form || !this.input || !this.results) {
          return;
        }

        this.bindEvents();
        this.syncInitialRecommendations();
        this.sortInitialRecommendations();
      }

      bindEvents() {
        this.input.addEventListener('input', () => {
          window.clearTimeout(this.debounceTimer);
          this.toggleReset();
          if (this.input.value.trim() === '') {
            this.showInitialRecommendations();
            return;
          }

          this.debounceTimer = window.setTimeout(() => this.handleInput(), 220);
        });

        this.input.addEventListener('focus', () => {
          const term = this.input.value.trim();
          if (term.length > 0) {
            this.handleInput();
            return;
          }

          this.showInitialRecommendations();
        });

        this.form.addEventListener('reset', () => {
          window.setTimeout(() => {
            this.results.hidden = true;
            this.showInitialRecommendations();
            this.toggleReset();
            this.input.focus();
          }, 0);
        });

        document.addEventListener('click', (event) => {
          const popdownToggle = event.target.closest ? event.target.closest('[data-popdown-toggle]') : null;
          if (popdownToggle && popdownToggle.getAttribute('data-popdown-toggle') === this.root.id) {
            this.handleToggle(event, popdownToggle);
            return;
          }

          if (this.root.contains(event.target)) {
            return;
          }

          if (this.root.classList.contains('is-visible')) {
            this.closePopdown();
            return;
          }

          this.close();
        }, true);

        this.root.querySelectorAll('[data-close-popdown]').forEach((button) => {
          button.addEventListener('click', (event) => {
            if (event.cancelable) {
              event.preventDefault();
            }

            this.closePopdown();
          });
        });

        const wrapper = this.root.closest('[data-search-popdown-wrap]');
        const underlay = wrapper ? wrapper.querySelector('[data-search-underlay]') : null;
        if (underlay) {
          underlay.addEventListener('click', () => this.closePopdown());
        }

        if (this.initial) {
          this.initial.addEventListener('click', (event) => {
            const card = event.target.closest ? event.target.closest('[data-sapiato-recommendation-card]') : null;
            if (card) {
              this.recordRecommendationClick(card);
            }
          });
        }

        this.root.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            this.closePopdown();
            this.input.blur();
          }
        });
      }

      handleInput() {
        const term = this.input.value.trim();
        if (term.length < 1) {
          this.showInitialRecommendations();
          return;
        }

        if (term.length < 2) {
          this.renderResults({}, term);
          return;
        }

        this.fetchResults(term);
      }

      async fetchResults(term) {
        if (this.abortController) {
          this.abortController.abort();
        }

        this.abortController = new AbortController();

        const routesRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : (this.root.dataset.routesRoot || '/');
        const url = new URL(`${routesRoot}search/suggest.json`, window.location.origin);
        url.searchParams.set('q', term);
        url.searchParams.set('resources[type]', 'product,collection,query');
        url.searchParams.set('resources[limit]', '6');
        url.searchParams.set('resources[limit_scope]', 'each');
        url.searchParams.set('resources[options][unavailable_products]', 'hide');
        url.searchParams.set('resources[options][fields]', 'title,product_type,variants.title,vendor');

        try {
          const response = await fetch(url.toString(), {
            credentials: 'same-origin',
            signal: this.abortController.signal
          });

          if (!response.ok) {
            throw new Error(response.status);
          }

          const suggestions = await response.json();
          this.renderResults(suggestions.resources && suggestions.resources.results ? suggestions.resources.results : {}, term);
        } catch (error) {
          if (error.name !== 'AbortError') {
            this.renderResults({}, term);
          }
        }
      }

      renderResults(results, term) {
        const queries = Array.isArray(results.queries) ? results.queries.slice(0, 4) : [];
        const suggestions = this.mergeSuggestions(
          this.getCuratedSuggestions(term, 8),
          queries.map((query) => ({
            title: query.text,
            url: query.url
          })),
          8
        );
        const products = this.rankProducts(Array.isArray(results.products) ? results.products : [], term).slice(0, 6);
        const collections = Array.isArray(results.collections) ? results.collections.slice(0, 4) : [];
        const parts = [];

        if (suggestions.length) {
          parts.push(this.renderSuggestions(suggestions, term));
        }

        if (products.length) {
          parts.push(this.renderProducts(products));
        }

        if (collections.length) {
          parts.push(this.renderLinks(this.root.dataset.collectionsLabel, collections.map((collection) => ({
            title: collection.title,
            url: collection.url
          }))));
        }

        if (!parts.length && this.initial && !this.hasSpecificSearchIntent(term)) {
          this.results.innerHTML = '';
          this.results.hidden = true;
          this.showRecommendationsBelowResults();
          return;
        }

        if (!parts.length) {
          parts.push(`<p class="sapiato-predictive__empty">${escapeHtml(this.root.dataset.emptyLabel)}</p>`);
        }

        if (term.trim().length > 0) {
          parts.push(`<a class="sapiato-predictive__view-all" href="${this.searchUrl(term)}">${escapeHtml(this.root.dataset.viewAllLabel)}</a>`);
        }

        this.results.innerHTML = parts.join('');
        if (term.trim().length > 0 && !this.hasSpecificSearchIntent(term)) {
          this.showRecommendationsBelowResults();
        } else {
          this.hideInitialRecommendations();
        }
        this.open();
      }

      hasSpecificSearchIntent(term) {
        return getSpecificSearchTokens(term).length > 0;
      }

      productSearchText(product) {
        const variants = Array.isArray(product.variants)
          ? product.variants.map((variant) => variant.title || '').join(' ')
          : '';

        return normalizeSearchTerm([
          product.title,
          product.product_type,
          product.vendor,
          product.url,
          variants
        ].filter(Boolean).join(' '));
      }

      rankProducts(products, term) {
        const normalizedTerm = normalizeSearchTerm(term);
        const tokens = getSearchTokens(term);
        const specificTokens = getSpecificSearchTokens(term);
        const specificPhrase = specificTokens.join(' ');

        return products
          .filter((product) => product.available !== false)
          .map((product, index) => {
            const text = this.productSearchText(product);
            const title = normalizeSearchTerm(product.title);
            const matchedTokens = tokens.filter((token) => text.includes(token)).length;
            const matchedSpecificTokens = specificTokens.filter((token) => text.includes(token)).length;
            let score = 0;

            if (productConflictsWithTerm(term, text)) {
              return { index, product, score: -1 };
            }

            if (specificTokens.length > 0) {
              const minimumSpecificMatches = Math.ceil(specificTokens.length * 0.75);
              if (matchedSpecificTokens < minimumSpecificMatches) {
                return { index, product, score: -1 };
              }

              score += matchedSpecificTokens * 40;
              if (specificPhrase && text.includes(specificPhrase)) {
                score += 120;
              }
            }

            if (normalizedTerm && title.includes(normalizedTerm)) {
              score += 100;
            }

            if (normalizedTerm && text.includes(normalizedTerm)) {
              score += 60;
            }

            score += matchedTokens * 10;

            return { index, product, score };
          })
          .filter((item) => item.score >= 0)
          .sort((a, b) => b.score - a.score || a.index - b.index)
          .map((item) => item.product);
      }

      loadRecommendationScores() {
        try {
          const stored = window.localStorage.getItem(recommendationScoreStorageKey);
          if (!stored) {
            return {};
          }

          const parsed = JSON.parse(stored);
          return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
        } catch (error) {
          return {};
        }
      }

      saveRecommendationScores() {
        try {
          const ranked = Object.entries(this.recommendationScores)
            .sort((a, b) => this.recommendationScoreValue(b[1]) - this.recommendationScoreValue(a[1]))
            .slice(0, recommendationScoreMaxItems);

          this.recommendationScores = Object.fromEntries(ranked);
          window.localStorage.setItem(recommendationScoreStorageKey, JSON.stringify(this.recommendationScores));
        } catch (error) {
        }
      }

      recommendationScoreValue(item) {
        if (!item) {
          return 0;
        }

        const lastClicked = Number(item.lastClicked) || 0;
        const ageDays = lastClicked ? (Date.now() - lastClicked) / 86400000 : recommendationScoreHalfLifeDays;
        const decay = Math.pow(0.5, Math.max(0, ageDays) / recommendationScoreHalfLifeDays);
        const clicks = Number(item.clicks) || 0;
        const score = Number(item.score) || 0;

        return (score + clicks * 3) * decay;
      }

      recommendationCardScore(card) {
        const key = card.dataset.sapiatoProductKey || card.getAttribute('href') || '';
        return this.recommendationScoreValue(this.recommendationScores[key]);
      }

      sortInitialRecommendations() {
        if (!this.initial) {
          return;
        }

        const grid = this.initial.querySelector('.sapiato-predictive__products--initial');
        if (!grid) {
          return;
        }

        const cards = Array.from(grid.querySelectorAll('[data-sapiato-recommendation-card]'));
        if (!cards.some((card) => this.recommendationCardScore(card) > 0)) {
          return;
        }

        cards
          .sort((a, b) => {
            const scoreDiff = this.recommendationCardScore(b) - this.recommendationCardScore(a);
            if (scoreDiff !== 0) {
              return scoreDiff;
            }

            return Number(a.dataset.sapiatoBaseRank || 0) - Number(b.dataset.sapiatoBaseRank || 0);
          })
          .forEach((card) => grid.appendChild(card));
      }

      recordRecommendationClick(card) {
        const key = card.dataset.sapiatoProductKey || card.getAttribute('href') || '';
        if (!key) {
          return;
        }

        const previous = this.recommendationScores[key] || {};
        const previousValue = this.recommendationScoreValue(previous);
        const clicks = (Number(previous.clicks) || 0) + 1;

        this.recommendationScores[key] = {
          clicks,
          lastClicked: Date.now(),
          score: previousValue + 12
        };

        this.saveRecommendationScores();

        window.dispatchEvent(new CustomEvent('sapiato:search-recommendation-click', {
          detail: {
            clicks,
            key,
            score: this.recommendationScores[key].score
          }
        }));

        if (Array.isArray(window.dataLayer)) {
          window.dataLayer.push({
            event: 'sapiato_search_recommendation_click',
            product_key: key,
            product_score: this.recommendationScores[key].score
          });
        }
      }

      parseCuratedSuggestions() {
        const parsedSuggestions = [];
        const script = this.root.querySelector('[data-sapiato-predictive-curated]');

        if (script) {
          try {
            const suggestions = JSON.parse(script.textContent);
            if (Array.isArray(suggestions)) {
              parsedSuggestions.push(...suggestions);
            }
          } catch (error) {
          }
        }

        this.root.querySelectorAll('[data-sapiato-predictive-source]').forEach((element) => {
          parsedSuggestions.push({
            default: element.dataset.default === 'true',
            terms: element.dataset.terms || '',
            title: element.dataset.title || '',
            url: element.dataset.url || ''
          });
        });

        return parsedSuggestions.filter((suggestion) => suggestion.title);
      }

      getCuratedSuggestions(term, limit) {
        const normalizedTerm = normalizeSearchTerm(term);
        const words = normalizedTerm ? normalizedTerm.split(' ').filter(Boolean) : [];

        return this.curatedSuggestions
          .map((suggestion, index) => ({
            index,
            score: this.scoreCuratedSuggestion(suggestion, normalizedTerm, words, index),
            title: suggestion.title,
            url: suggestion.url || this.searchUrl(suggestion.title)
          }))
          .filter((suggestion) => suggestion.score >= 0)
          .sort((a, b) => b.score - a.score || a.index - b.index)
          .slice(0, limit)
          .map((suggestion) => ({
            title: suggestion.title,
            url: suggestion.url
          }));
      }

      scoreCuratedSuggestion(suggestion, normalizedTerm, words, index) {
        if (!normalizedTerm) {
          return suggestion.default ? 100 - index : 20 - index;
        }

        const normalizedTitle = normalizeSearchTerm(suggestion.title);
        const normalizedTerms = normalizeSearchTerm(`${suggestion.title} ${suggestion.terms || ''}`);

        if (normalizedTitle === normalizedTerm) {
          return 120;
        }

        if (normalizedTitle.startsWith(normalizedTerm)) {
          return 100;
        }

        if (normalizedTerms.includes(normalizedTerm)) {
          return 80;
        }

        if (words.length > 0 && words.every((word) => normalizedTerms.includes(word))) {
          return 60;
        }

        return -1;
      }

      mergeSuggestions(primary, secondary, limit) {
        const seen = new Set();

        return primary.concat(secondary).filter((item) => {
          const key = normalizeSearchTerm(item.title);
          if (!key || seen.has(key)) {
            return false;
          }

          seen.add(key);
          return true;
        }).slice(0, limit);
      }

      renderLinks(title, items) {
        const links = items.map((item) => (
          `<a class="sapiato-predictive__link" href="${escapeHtml(item.url)}" role="option">${escapeHtml(item.title)}</a>`
        )).join('');

        return `
          <div class="sapiato-predictive__section">
            <p class="sapiato-predictive__heading">${escapeHtml(title)}</p>
            <div class="sapiato-predictive__links">${links}</div>
          </div>
        `;
      }

      renderSuggestions(items, term) {
        const links = items.map((item) => (
          `<a class="sapiato-predictive__suggestion" href="${escapeHtml(item.url)}" role="option">${this.renderSuggestionLabel(item.title, term)}</a>`
        )).join('');

        return `
          <div class="sapiato-predictive__section sapiato-predictive__section--suggestions">
            <div class="sapiato-predictive__suggestions">${links}</div>
          </div>
        `;
      }

      renderSuggestionLabel(title, term) {
        const titleText = String(title || '');
        const termText = String(term || '').trim();

        if (!termText || !normalizeSearchTerm(titleText).startsWith(normalizeSearchTerm(termText))) {
          return escapeHtml(titleText);
        }

        const head = titleText.slice(0, termText.length);
        const tail = titleText.slice(termText.length);
        return `${escapeHtml(head)}<span class="sapiato-predictive__suggestion-tail">${escapeHtml(tail)}</span>`;
      }

      renderProducts(products) {
        const cards = products.map((product) => {
          const image = product.featured_image && product.featured_image.url ? product.featured_image.url : product.image;
          const imageMarkup = image
            ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(product.title)}" loading="lazy">`
            : '';
          const price = formatPrice(product.price, this.locale, this.currency);

          return `
            <a class="sapiato-predictive__product" href="${escapeHtml(product.url)}" role="option">
              <span class="sapiato-predictive__image">${imageMarkup}</span>
              <span class="sapiato-predictive__product-body">
                <span class="sapiato-predictive__title">${escapeHtml(product.title)}</span>
                ${price ? `<span class="sapiato-predictive__price">${escapeHtml(price)}</span>` : ''}
              </span>
            </a>
          `;
        }).join('');

        return `
          <div class="sapiato-predictive__section">
            <p class="sapiato-predictive__heading">${escapeHtml(this.root.dataset.productsLabel)}</p>
            <div class="sapiato-predictive__products">${cards}</div>
          </div>
        `;
      }

      searchUrl(term) {
        const routesRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : (this.root.dataset.routesRoot || '/');
        const url = new URL(`${routesRoot}search`, window.location.origin);
        url.searchParams.set('type', 'product');
        url.searchParams.set('options[unavailable_products]', 'hide');
        url.searchParams.set('options[prefix]', 'last');
        url.searchParams.set('q', term);
        return url.toString();
      }

      open() {
        this.results.hidden = false;
        this.input.setAttribute('aria-expanded', 'true');
      }

      close() {
        this.results.hidden = true;
        this.hideInitialRecommendations();
        this.input.setAttribute('aria-expanded', 'false');
      }

      handleToggle(event, toggle) {
        if (event.cancelable) {
          event.preventDefault();
        }

        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        } else {
          event.stopPropagation();
        }

        this.openPopdown(toggle);
        this.refreshOpenContent();
        this.input.focus({ preventScroll: true });

        window.setTimeout(() => {
          this.refreshOpenContent();
          this.input.focus({ preventScroll: true });
        }, 0);
      }

      openPopdown(toggle) {
        const wrapper = this.root.closest('[data-search-popdown-wrap]');
        const underlay = wrapper ? wrapper.querySelector('[data-search-underlay]') : null;

        this.activeToggle = toggle || this.activeToggle;
        this.root.classList.add('is-visible');

        if (underlay) {
          underlay.classList.add('underlay--visible');
        }

        document.querySelectorAll(`[data-popdown-toggle="${this.root.id}"]`).forEach((trigger) => {
          trigger.setAttribute('aria-haspopup', 'dialog');
          trigger.setAttribute('aria-expanded', trigger === this.activeToggle ? 'true' : 'false');
          trigger.setAttribute('aria-controls', this.root.id);
        });
      }

      closePopdown() {
        const wrapper = this.root.closest('[data-search-popdown-wrap]');
        const underlay = wrapper ? wrapper.querySelector('[data-search-underlay]') : null;

        this.root.classList.remove('is-visible');

        if (underlay) {
          underlay.classList.remove('underlay--visible');
        }

        document.querySelectorAll(`[data-popdown-toggle="${this.root.id}"]`).forEach((trigger) => {
          trigger.setAttribute('aria-expanded', 'false');
        });

        this.close();
      }

      refreshOpenContent() {
        this.toggleReset();

        if (this.input.value.trim() === '') {
          this.showInitialRecommendations();
          return;
        }

        this.handleInput();
      }

      showInitialRecommendations() {
        if (!this.initial) {
          this.renderResults({}, '');
          return;
        }

        this.results.hidden = true;
        this.initial.hidden = false;
        this.input.setAttribute('aria-expanded', 'false');
      }

      showRecommendationsBelowResults() {
        if (this.initial) {
          this.initial.hidden = false;
        }
      }

      hideInitialRecommendations() {
        if (this.initial) {
          this.initial.hidden = true;
        }
      }

      syncInitialRecommendations() {
        if (!this.initial) {
          return;
        }

        this.initial.hidden = this.isDrawer && this.input.value.trim() === '';
      }

      toggleReset() {
        if (!this.reset) {
          return;
        }

        this.reset.classList.toggle('is-hidden', this.input.value.trim() === '');
      }
    }

    const initSapiatoPredictiveSearch = (container = document) => {
      container.querySelectorAll('[data-sapiato-predictive-search]').forEach((root) => {
        if (root.dataset.sapiatoPredictiveEnhanced === 'true') {
          return;
        }

        root.dataset.sapiatoPredictiveEnhanced = 'true';
        new SapiatoPredictiveSearch(root);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initSapiatoPredictiveSearch(), { once: true });
    } else {
      initSapiatoPredictiveSearch();
    }
    document.addEventListener('shopify:section:load', (event) => initSapiatoPredictiveSearch(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
